export default "__VITE_ASSET__CxoMs0hu__"